<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        <div class="text-h4" style="margin-top: 15px;">
            支払方法更新</v-btn>
        </div>

        <!-- 項目 -->
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-container>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>支払方法</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:50" v-slot="{ errors }">
                            <v-select outlined clearable v-disabled-icon-focus v-model="nowPaymentMethod" :items="paymentmethodList" :error-messages="errors" background-color="white" placeholder="ご選択ください"></v-select>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>請求担当者名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_name" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>部署名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_department" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>TEL</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider name="TEL" rules="required|numeric|min:10|max:11" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_tel" placeholder="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>メールアドレス</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="5">
                        <ValidationProvider rules="required|email|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_email_address_main" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>メールアドレス CC:</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="5">
                        <ValidationProvider rules="email|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_email_address_sub" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row class="justify-center">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk" :disabled="invalid">
                        <slot name="ok-btn" :disabled="invalid">保存</slot>
                    </v-btn>
                </v-row>
            </v-container>
        </ValidationObserver>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                paymentmethodList: [],
                nowPaymentMethod: '',
                invoiceInfo: {},
                // メッセージ
                message: null,
                success: false,
                aid: null,
                sending: false,
            };
        },
        methods: {
            // 更新
            pushOk: async function(tkn) {
                this.sending = true;
                await axios.post('/documents/update-invoices', {
                    payment_method: this.nowPaymentMethod,
                    billing_name: this.invoiceInfo.billing_name,
                    billing_department: this.invoiceInfo.billing_department,
                    billing_tel: this.invoiceInfo.billing_tel,
                    billing_email_address_main: this.invoiceInfo.billing_email_address_main,
                    billing_email_address_sub: this.invoiceInfo.billing_email_address_sub,
                    token: tkn,
                }).then(res => {
                    this.success = res.data.success;
                    this.message = res.data.message;
                }).catch(res => {
                    this.success = false;
                    this.message = "処理に失敗しました";
                }).finally(() => {
                    this.sending = false;
                });
            },
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-invoices').then(res => {
                this.paymentmethodList = res.data.paymentmethodList;
                this.nowPaymentMethod = res.data.nowPaymentMethod;
                this.invoiceInfo = res.data.invoiceInfo;
                this.aid = res.data.aid;
            });
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .col-12, .col-xl-12 {
        padding: 12px 12px 0 12px;
    }
</style>